import styled from "styled-components";

const SnackWrapper = styled.div`
  .success {
    .MuiSnackbarContent-root {
      background-color: rgb(46, 125, 50);
    }
  }

  .error {
    .MuiSnackbarContent-root {
      background-color: rgb(211, 47, 47);
    }
  }

  .warning {
    .MuiSnackbarContent-root {
      background-color: rgb(237 182 2);
    }
  }

  .info {
    .MuiSnackbarContent-root {
      background-color: rgb(2, 136, 209);
    }
  }
`;

export default SnackWrapper;
